import * as z from "zod/v4";

export const verifyPassword = {
  name: "verifyPassword" as const,
  input: z.object({ email: z.string(), password: z.string() }),
  output: z.object({ merchantAuthToken: z.string() }),
};
